import { CanActivateFn } from '@angular/router';
import { billingSsoUrl } from '../services/billing-navigation';
export const billingRedirectGuard:CanActivateFn=(route)=>{
  const tab=route.queryParamMap.get('tab');
  if(route.routeConfig?.path==='my-account/telecom'||tab==='billing'||tab==='invoices'){
    window.location.replace(billingSsoUrl(route.routeConfig?.path==='my-account/telecom'?'/invoices?tab=monthly':tab==='billing'?'/payment-methods':'/invoices'));return false;
  }
  return true;
};
